var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"loading-mask-wrapper",class:{
    'loading-mask-wrapper-flex': _vm.flex,
    'loading-mask-auto': _vm.autoHeight,
  },attrs:{"h-100":""}},[_c('transition',{attrs:{"name":"loading-mask-fade"}},[(_vm.loading)?_c('div',{staticClass:"loading-mask",class:_vm.loadingMaskBgClass,style:(_vm.loadingMaskStyles)},[_c('div',{staticClass:"row"},[_c(_vm.spinnerComponent,_vm._b({tag:"component"},'component',_vm.spinnerConfig,false))],1)]):_vm._e()]),_vm._t("content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }